var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "copyright-block container" },
    [
      _vm._v(
        "\n  Указанная стоимость товаров и условия их приобретения действительны по состоянию на текущую дату.\n  "
      ),
      _c("recaptcha-text"),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n  © 2022, FUNDAY. Все права защищены. Юридический адрес: г. Москва, ул. Профсоюзная, д. 61А\n"
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }